import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import IconButton from '@mui/material/IconButton';
import { WsDataTable } from 'wisestep-base';

import { SettingsPageLayout } from '../../../components/SettingsPageLayout';

const PrismExtensionPage = () => {
  const columns = [
    {
      Header: 'Version',
      accessor: 'version',
    },
    {
      Header: 'Updated Date',
      accessor: 'updatedDate',
    },
    {
      Header: 'Download',
      accessor: 'download',
    },
  ];

  const data = [
    {
      version: 'Prism Version 2.5.12',
      updatedDate: '12 SEP 2023',
      download: (
        <IconButton
          onClick={() =>
            window.open(
              'https://wisestep-open.s3.eu-west-1.amazonaws.com/prism+2.5.12.zip',
              '_blank'
            )
          }
        >
          <FileDownloadOutlinedIcon color="primary" />
        </IconButton>
      ),
    },
    {
      version: 'Prism Version 2.5.5',
      updatedDate: 'AUG 2023',
      download: (
        <IconButton
          onClick={() =>
            window.open(
              'https://wisestep-open.s3.eu-west-1.amazonaws.com/extension+(100).zip',
              '_blank'
            )
          }
        >
          <FileDownloadOutlinedIcon color="primary" />
        </IconButton>
      ),
    },
    {
      version: 'Prism Version 2.1.2',
      updatedDate: '13 DEC 2022',
      download: (
        <IconButton
          onClick={() =>
            window.open('https://wisestep-open.s3.amazonaws.com/Prism-2.1.2.zip', '_blank')
          }
        >
          <FileDownloadOutlinedIcon color="primary" />
        </IconButton>
      ),
    },
    {
      version: 'Prism Version 2.1.1',
      updatedDate: '29 AUG 2022',
      download: '',
    },
  ];

  return (
    <SettingsPageLayout
      title="Prism Extension"
      indexOptions={[{ label: 'Prism Download', url: '' }]}
      // backUrl={'/app-settings/apps-and-integrations'}
      goBackRequired={false}
    >
      <WsDataTable
        columns={columns}
        data={data ?? []}
        boldItems={['version', 'updatedDate']}
        dense={false}
        pageable={true}
      />
    </SettingsPageLayout>
  );
};

export default PrismExtensionPage;
